import { useRouter } from 'expo-router';
import React, { useEffect } from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import {
  NavigationButton,
  NavigationButtonTypes,
} from '@/components/navigation-button';
import { Button, Text } from '@/ui';

export default function ModifyRentalModal({
  visible = false,
  onClose,
  id,
}: {
  visible?: boolean;
  onClose?: () => void;
  id: string;
}) {
  const { styles, theme } = useStyles(stylesheet);
  const router = useRouter();
  const [showModal, setShowModal] = React.useState(visible);

  useEffect(() => {
    setShowModal(visible);
  }, [visible]);

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={1000}
      isVisible={showModal}
      hasBackdrop
      style={styles.modifyRentalContainer}
      onBackdropPress={() => {
        onClose?.();
        setShowModal(false);
      }}
    >
      <View
        style={{
          backgroundColor: theme.colors.background_2,
          borderRadius: 16,
          paddingLeft: 16,
          paddingRight: 16,
          gap: 32,
          paddingBottom: 16,
        }}
      >
        <View
          style={{
            alignSelf: 'center',
            marginTop: 16,
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <Text type="title2">Modify Rental</Text>

          <NavigationButton
            type={NavigationButtonTypes.cancel}
            onPress={() => {
              onClose?.();
              setShowModal(false);
            }}
            style={{
              position: 'absolute',
              right: 0,
            }}
          />
        </View>

        <View style={{ flexGrow: 1, width: '100%', gap: 8 }}>
          <Button
            text="Change Car"
            type="secondary"
            onPress={() => {
              onClose?.();
              setShowModal(false);
              router.push(`/partner/reservations/${id}/change-car`);
            }}
            style={{
              backgroundColor: theme.colors.button.secondary.hover.fill,
            }}
          />

          <Button
            text="Cancel Trip"
            type="secondary"
            onPress={() => {
              onClose?.();
              setShowModal(false);
              router.push(`/partner/reservations/${id}/cancel`);
            }}
            style={{
              backgroundColor: theme.colors.button.secondary.hover.fill,
            }}
            textStyle={{ color: theme.colors.error }}
          />
        </View>
      </View>
    </Modal>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  modifyRentalContainer: {
    margin: 0,
    justifyContent: 'center',
    alignSelf: 'center',
    maxWidth: {
      xs: '100%',
      sm: 600,
      md: 600,
    },
    width: {
      xs: '100%',
      md: 700,
    },
  },
}));
